// extracted by mini-css-extract-plugin
module.exports = {"profileSummarySectionContainer":"_1xqMXQKc","moneyRangeData":"_18T6Y-HU","moneyRangeTitle":"_2NhKIG7O","recruiterInsights":"_1THOW1V5","screenshotView":"_3mEBmZ73"};
    if(module.hot) {
      // 1754514989392
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  